import React, { useEffect, useState, useRef } from 'react';
import {
    fetchTodayGames,
    fetchUserJoinedSquads
} from '../api/api';

function Home() {
    const todayString = new Date().toISOString().split("T")[0];

    const [todayGames, setTodayGames] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedRow, setExpandedRow] = useState(null);
    const [selectedDate, setSelectedDate] = useState(todayString);
    const [joinedSquads, setJoinedSquads] = useState([]);
    const [selectedSquad, setSelectedSquad] = useState(() => {
        const saved = localStorage.getItem("home-squad-filter");

        return saved && saved !== "all"
            ? saved
            : "all";
    });

    const loggedUser = JSON.parse(
        localStorage.getItem("user")
    );
    const dateInputRef = useRef(null);
    
    const filterOptions = [
        { id: "all", name: "All" }
    ];

    const loadTodayGames = async (
        date = null,
        squadId = null
    ) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetchTodayGames(
                date,
                squadId
            );
            setTodayGames(response.data);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const toggleExpand = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };

    const shiftDate = (days) => {
        const date = new Date(selectedDate);

        date.setDate(date.getDate() + days);

        setSelectedDate(
            date.toISOString().split("T")[0]
        );
    };

    const formatSelectedDate = () => {
        return new Intl.DateTimeFormat(
            "en-GB",
            {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }
        ).format(new Date(selectedDate));
    };

    const loadSquads = async () => {
        if (!loggedUser) {
            return;
        }

        try {
            const response = await fetchUserJoinedSquads();

            setJoinedSquads(response.data || []);
        } catch (err) {
            console.error(
                "Failed to load squads",
                err
            );
        }
    };

    useEffect(() => {
        loadTodayGames(
            selectedDate === todayString
                ? null
                : selectedDate,

            selectedSquad === "all"
                ? null
                : selectedSquad
        );
    }, [selectedDate, selectedSquad]);

    useEffect(() => {
        if (!todayGames || todayGames.length === 0) {
            setExpandedRow(null);
            return;
        }

        const firstLiveGame = todayGames.findIndex(
            game =>
                game.status === "live" &&
                game.predictions.length > 0
        );

        setExpandedRow(
            firstLiveGame !== -1
                ? firstLiveGame
                : null
        );
    }, [todayGames]);

    useEffect(() => {
        loadSquads();
    }, []);

    useEffect(() => {
        localStorage.setItem(
            "home-squad-filter",
            selectedSquad
        );
    }, [selectedSquad]);

    const formatTimestamp = (timestamp) => {
        const date = new Date(timestamp * 1000); // Convert to milliseconds

        return new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }).format(date);
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;

    return (
        <div className="content-container">
            <div className="filter-dropdown-container">
                <div className="home-toolbar">

                    <button
                        className="date-nav-button"
                        onClick={() => shiftDate(-1)}
                    >
                        ←
                    </button>

                    <div
                        className="selected-date"
                        onClick={() => {
                            if (dateInputRef.current?.showPicker) {
                                dateInputRef.current.showPicker();
                            } else {
                                dateInputRef.current?.click();
                            }
                        }}
                    >
                        {formatSelectedDate()}
                    </div>

                    <input
                        ref={dateInputRef}
                        type="date"
                        value={selectedDate}
                        onChange={(e) =>
                            setSelectedDate(e.target.value)
                        }
                        className="hidden-date-input"
                    />

                    <button
                        className="date-nav-button"
                        onClick={() => shiftDate(1)}
                    >
                        →
                    </button>

                    <select
                        value={selectedSquad}
                        onChange={(e) =>
                            setSelectedSquad(e.target.value)
                        }
                        className="filter-dropdown points-dropdown"
                    >
                        <option value="all">
                            All
                        </option>

                        {joinedSquads.map((squad) => (
                            <option
                                key={squad.slug}
                                value={squad.slug}
                            >
                                {squad.name}
                            </option>
                        ))}
                    </select>

                </div>
            </div>
            <div className="today-games dark-main-container">
                {todayGames?.length === 0 ? (

                    <div className="empty-state">
                        No games available for selected date.
                    </div>

                ) : (

                    <div className="predictions-container">
                        <div className="today-games-desktop">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Time</th>
                                        <th className="left">Game</th>
                                        <th></th>
                                        <th>Points</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {todayGames.map((game, index) => (
                                        <React.Fragment key={index}>

                                            <tr>
                                                <td>
                                                    {formatTimestamp(game.start_time)}
                                                </td>

                                                <td className="match-info">
                                                    {game.home_name}

                                                    <img
                                                        src={game.home_image}
                                                        alt={game.home_name}
                                                        className="team-img"
                                                    />

                                                    <span className="highlight">
                                                        {(game.results !== null &&
                                                            game.status === "finished")
                                                            ? `${game.results.home}:${game.results.away} (${game.results["home-ht"]}:${game.results["away-ht"]})`
                                                            : ""
                                                        }
                                                    </span>

                                                    <img
                                                        src={game.away_image}
                                                        alt={game.away_name}
                                                        className="team-img"
                                                    />

                                                    {game.away_name}
                                                </td>

                                                <td
                                                    className={
                                                        game.status === "login" ||
                                                        game.status === "unpredicted"
                                                            ? "alert-text"
                                                            : ""
                                                    }
                                                >
                                                    {game.status === "live" && (
                                                        <span
                                                            className="live-indicator"
                                                            data-tooltip="Live"
                                                        />
                                                    )}

                                                    {game.status === "live"
                                                        ? (
                                                            game.results != null
                                                                ? ` ${game.results.home}:${game.results.away} (${game.results["home-ht"]}:${game.results["away-ht"]})`
                                                                : " 0:0 (0:0)"
                                                        )
                                                        : game.status
                                                    }
                                                </td>

                                                <td></td>

                                                {game.predictions.length > 0 ? (
                                                    <td
                                                        className="expand-icon"
                                                        onClick={() =>
                                                            toggleExpand(index)
                                                        }
                                                    >
                                                        <span
                                                            className={`sort-icon ${
                                                                expandedRow === index
                                                                    ? "asc"
                                                                    : "desc"
                                                            }`}
                                                        />
                                                    </td>
                                                ) : (
                                                    <td></td>
                                                )}
                                            </tr>

                                            {expandedRow === index &&
                                                game.predictions.map(
                                                    (prediction, predictionIndex) => (
                                                        <tr
                                                            key={predictionIndex}
                                                            className={`expanded-row ${
                                                                prediction.me
                                                                    ? "highlight"
                                                                    : ""
                                                            }`}
                                                        >
                                                            <td
                                                                colSpan="2"
                                                                className="left"
                                                            >
                                                                <div className="expanded-content">
                                                                    <div className="home-user-info">
                                                                        #{predictionIndex + 1}

                                                                        <img
                                                                            src={prediction.country_img}
                                                                            alt={prediction.country}
                                                                            title={prediction.country}
                                                                            className="home-country-flag"
                                                                        />

                                                                        {prediction.username}
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className="expanded-content">
                                                                    <div>
                                                                        {prediction.prediction == null
                                                                            ? "?"
                                                                            : `${prediction.prediction.home}:${prediction.prediction.away} (${prediction.prediction.halftime})`
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <div className="expanded-content">
                                                                    <div>
                                                                        {prediction.points}
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td></td>
                                                        </tr>
                                                    )
                                                )
                                            }

                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="today-games-mobile">
                            {todayGames.map((game, index) => (
                                <div
                                    key={index}
                                    className="mobile-game-card"
                                >
                                    <div className="mobile-game-header">
                                        <span>
                                            {formatTimestamp(game.start_time)}
                                        </span>

                                        <span
                                            className={
                                                game.status === "login" ||
                                                game.status === "unpredicted"
                                                    ? "alert-text"
                                                    : ""
                                            }
                                        >
                                            {game.status === "live" && (
                                                <span
                                                    className="live-indicator"
                                                    data-tooltip="Live"
                                                />
                                            )}

                                            {game.status === "live"
                                                ? (
                                                    game.results != null
                                                        ? ` ${game.results.home}:${game.results.away}`
                                                        : " 0:0"
                                                )
                                                : game.status
                                            }
                                        </span>
                                    </div>

                                    <div className="mobile-game-match">

                                        <div className="mobile-team">
                                            <img
                                                src={game.home_image}
                                                alt={game.home_name}
                                                className="team-img"
                                            />

                                            <span>{game.home_name}</span>
                                        </div>

                                        <div className="mobile-vs">
                                            VS
                                        </div>

                                        <div className="mobile-team">
                                            <img
                                                src={game.away_image}
                                                alt={game.away_name}
                                                className="team-img"
                                            />

                                            <span>{game.away_name}</span>
                                        </div>

                                    </div>

                                    {game.results &&
                                        game.status === "finished" && (
                                            <div className="mobile-result">
                                                {game.results.home}:{game.results.away}
                                                {" "}
                                                (
                                                {game.results["home-ht"]}:
                                                {game.results["away-ht"]}
                                                )
                                            </div>
                                        )
                                    }

                                    {game.predictions.length > 0 && (
                                        <>
                                            <button
                                                className="arena-toggle-button"
                                                onClick={() => toggleExpand(index)}
                                            >
                                                {expandedRow === index
                                                    ? "Hide predictions"
                                                    : `Show predictions (${game.predictions.length})`
                                                }
                                            </button>

                                            {expandedRow === index && (
                                                <div className="mobile-predictions">

                                                    {game.predictions.map(
                                                        (prediction, predictionIndex) => (
                                                            <div
                                                                key={predictionIndex}
                                                                className={`mobile-prediction ${
                                                                    prediction.me
                                                                        ? "highlight"
                                                                        : ""
                                                                }`}
                                                            >
                                                                <div className="mobile-prediction-user">

                                                                    <span>
                                                                        #{predictionIndex + 1}
                                                                    </span>

                                                                    <img
                                                                        src={prediction.country_img}
                                                                        alt={prediction.country}
                                                                        className="home-country-flag"
                                                                    />

                                                                    <span>
                                                                        {prediction.username}
                                                                    </span>

                                                                </div>

                                                                <div className="mobile-prediction-data">

                                                                    <span>
                                                                        {prediction.prediction == null
                                                                            ? "?"
                                                                            : `${prediction.prediction.home}:${prediction.prediction.away} (${prediction.prediction.halftime})`
                                                                        }
                                                                    </span>

                                                                    <span>
                                                                        {prediction.points} pts
                                                                    </span>

                                                                </div>
                                                            </div>
                                                        )
                                                    )}

                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Home;
